import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ANNOUNCEMENTS_CAROUSEL_TIMEOUT_MS } from "newApp/utilities/Constants";
import Announcement from "newApp/components/EmailLogin/Announcement";
import Banner from "@p1s/p1s-common-react/entities/Banner";

export const AnnouncementCarousel = ({ announcements }) => {
    if (!announcements || announcements.length === 0)
        return null;

    const itemClass = "carousel-slide";
    const items = announcements;
    const [currentSlide, setCurrentSlide] = useState(1);
    useEffect(() => {
        const interval = setInterval(() => {
            if (items.length > 1) {
                const nextSlide = items.length > currentSlide ? currentSlide + 1 : 1;
                setCurrentSlide(nextSlide);
            }
        }, ANNOUNCEMENTS_CAROUSEL_TIMEOUT_MS);

        return () => {
            clearInterval(interval);
        };
    }, [currentSlide]);

    const parseCarouselItems = (item, index) => {
        const isActiveClass = index === currentSlide ? " active" : "";
        const isNext = (index === currentSlide + 1 || items.length > 1 && items.length === currentSlide && index === 1) ? " next" : "";
        const isFirst = index === 1 && items.length <= 2 ? " first" : "";

        return (
            <div
                className={itemClass + isActiveClass + isNext + isFirst}
                id={`${itemClass + index}`}
                tabIndex="0"
                key={index}>
                <div className="slide-content">
                    <Announcement announcement={item}/>
                </div>
            </div>);
    };

    const parseCarouselNavigation = (index) => {
        const buttonClass = index === currentSlide ? "carousel-navigation-button active" : "carousel-navigation-button";
        return (
            <li
                className="carousel-navigation-item"
                data-slide-to={index}
                data-target="#carousel"
                key={"nav" + index}>
                <span className={buttonClass} onClick={() => setCurrentSlide(index)} />
            </li>
        );
    };

    return (
        <section className="carousel" id="carousel">
            <div className="carousel-viewport">
                {items.map((item, index) => parseCarouselItems(item, index + 1))}
            </div>
            <aside className="carousel-navigation">
                <ol className="carousel-navigation-list">
                    {items.length > 1 && items.map((item, index) => parseCarouselNavigation(index + 1))}
                </ol>
            </aside>
        </section>);
};

AnnouncementCarousel.propTypes = {
    announcements: PropTypes.arrayOf(PropTypes.instanceOf(Banner)).isRequired
};

export default AnnouncementCarousel;
